export const UserProfileController = [
    '$scope', '$window', 'Meeting',
    function($scope, $window, Meeting) {
        Meeting.getByRouteParams().then(function(meeting) {
            $scope.meeting = meeting;
        });
    },
];
